import { render, staticRenderFns } from "./OurStoryStars.vue?vue&type=template&id=2aa57665&scoped=true&"
import script from "./OurStoryStars.vue?vue&type=script&lang=js&"
export * from "./OurStoryStars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa57665",
  null
  
)

export default component.exports